"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const prop_types_1 = __importDefault(require("prop-types"));
const get_css_1 = __importDefault(require("../get-css"));
exports.propTypes = {
    columnGap: prop_types_1.default.oneOfType([prop_types_1.default.string, prop_types_1.default.number]),
    gap: prop_types_1.default.oneOfType([prop_types_1.default.string, prop_types_1.default.number]),
    grid: prop_types_1.default.string,
    gridArea: prop_types_1.default.string,
    gridAutoColumns: prop_types_1.default.oneOfType([prop_types_1.default.string, prop_types_1.default.number]),
    gridAutoFlow: prop_types_1.default.string,
    gridAutoRows: prop_types_1.default.oneOfType([prop_types_1.default.string, prop_types_1.default.number]),
    gridColumn: prop_types_1.default.oneOfType([prop_types_1.default.string, prop_types_1.default.number]),
    gridColumnEnd: prop_types_1.default.oneOfType([prop_types_1.default.string, prop_types_1.default.number]),
    gridColumnGap: prop_types_1.default.oneOfType([prop_types_1.default.string, prop_types_1.default.number]),
    gridColumnStart: prop_types_1.default.oneOfType([prop_types_1.default.string, prop_types_1.default.number]),
    gridGap: prop_types_1.default.oneOfType([prop_types_1.default.string, prop_types_1.default.number]),
    gridRow: prop_types_1.default.oneOfType([prop_types_1.default.string, prop_types_1.default.number]),
    gridRowEnd: prop_types_1.default.oneOfType([prop_types_1.default.string, prop_types_1.default.number]),
    gridRowGap: prop_types_1.default.oneOfType([prop_types_1.default.string, prop_types_1.default.number]),
    gridRowStart: prop_types_1.default.oneOfType([prop_types_1.default.string, prop_types_1.default.number]),
    gridTemplate: prop_types_1.default.string,
    gridTemplateAreas: prop_types_1.default.string,
    gridTemplateColumns: prop_types_1.default.string,
    gridTemplateRows: prop_types_1.default.string,
    rowGap: prop_types_1.default.oneOfType([prop_types_1.default.string, prop_types_1.default.number])
};
exports.propAliases = {};
exports.propValidators = {};
const columnGap = {
    className: 'col-gap',
    cssName: 'column-gap',
    jsName: 'columnGap'
};
const gap = {
    className: 'gap',
    cssName: 'gap',
    jsName: 'gap'
};
const grid = {
    className: 'grd',
    cssName: 'grid',
    jsName: 'grid',
    complexValue: true
};
const gridArea = {
    className: 'grd-ara',
    cssName: 'grid-area',
    jsName: 'gridArea',
    complexValue: true
};
const gridAutoColumns = {
    className: 'grd-ato-col',
    cssName: 'grid-auto-columns',
    jsName: 'gridAutoColumns',
    complexValue: true
};
const gridAutoFlow = {
    className: 'grd-ato-flw',
    cssName: 'grid-auto-flow',
    jsName: 'gridAutoFlow'
};
const gridAutoRows = {
    className: 'grd-ato-row',
    cssName: 'grid-auto-rows',
    jsName: 'gridAutoRows',
    complexValue: true
};
const gridColumn = {
    className: 'grd-col',
    cssName: 'grid-column',
    jsName: 'gridColumn',
    defaultUnit: '',
    complexValue: true
};
const gridColumnEnd = {
    className: 'grd-col-end',
    cssName: 'grid-column-end',
    jsName: 'gridColumnEnd',
    defaultUnit: ''
};
const gridColumnGap = {
    className: 'grd-col-gap',
    cssName: 'grid-column-gap',
    jsName: 'gridColumnGap'
};
const gridColumnStart = {
    className: 'grd-col-str',
    cssName: 'grid-column-start',
    jsName: 'gridColumnStart',
    defaultUnit: ''
};
const gridGap = {
    className: 'grd-gap',
    cssName: 'grid-gap',
    jsName: 'gridGap'
};
const gridRow = {
    className: 'grd-row',
    cssName: 'grid-row',
    jsName: 'gridRow',
    defaultUnit: '',
    complexValue: true
};
const gridRowEnd = {
    className: 'grd-row-end',
    cssName: 'grid-row-end',
    jsName: 'gridRowEnd',
    defaultUnit: ''
};
const gridRowGap = {
    className: 'grd-row-gap',
    cssName: 'grid-row-gap',
    jsName: 'gridRowGap'
};
const gridRowStart = {
    className: 'grd-row-str',
    cssName: 'grid-row-start',
    jsName: 'gridRowStart',
    defaultUnit: ''
};
const gridTemplate = {
    className: 'grd-tmp',
    cssName: 'grid-template',
    jsName: 'gridTemplate',
    complexValue: true
};
const gridTemplateAreas = {
    className: 'grd-tmp-ara',
    cssName: 'grid-template-areas',
    jsName: 'gridTemplateAreas',
    complexValue: true
};
const gridTemplateColumns = {
    className: 'grd-tmp-col',
    cssName: 'grid-template-columns',
    jsName: 'gridTemplateColumns',
    complexValue: true
};
const gridTemplateRows = {
    className: 'grd-tmp-row',
    cssName: 'grid-template-rows',
    jsName: 'gridTemplateRows',
    complexValue: true
};
const rowGap = {
    className: 'row-gap',
    cssName: 'row-gap',
    jsName: 'rowGap'
};
exports.propEnhancers = {
    columnGap: (value) => get_css_1.default(columnGap, value),
    gap: (value) => get_css_1.default(gap, value),
    grid: (value) => get_css_1.default(grid, value),
    gridArea: (value) => get_css_1.default(gridArea, value),
    gridAutoColumns: (value) => get_css_1.default(gridAutoColumns, value),
    gridAutoFlow: (value) => get_css_1.default(gridAutoFlow, value),
    gridAutoRows: (value) => get_css_1.default(gridAutoRows, value),
    gridColumn: (value) => get_css_1.default(gridColumn, value),
    gridColumnEnd: (value) => get_css_1.default(gridColumnEnd, value),
    gridColumnGap: (value) => get_css_1.default(gridColumnGap, value),
    gridColumnStart: (value) => get_css_1.default(gridColumnStart, value),
    gridGap: (value) => get_css_1.default(gridGap, value),
    gridRow: (value) => get_css_1.default(gridRow, value),
    gridRowEnd: (value) => get_css_1.default(gridRowEnd, value),
    gridRowGap: (value) => get_css_1.default(gridRowGap, value),
    gridRowStart: (value) => get_css_1.default(gridRowStart, value),
    gridTemplate: (value) => get_css_1.default(gridTemplate, value),
    gridTemplateAreas: (value) => get_css_1.default(gridTemplateAreas, value),
    gridTemplateColumns: (value) => get_css_1.default(gridTemplateColumns, value),
    gridTemplateRows: (value) => get_css_1.default(gridTemplateRows, value),
    rowGap: (value) => get_css_1.default(rowGap, value)
};
//# sourceMappingURL=data:application/json;base64,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